import React from 'react';

export const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Conditions d'utilisation</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 text-sm mb-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-CH')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptation des conditions</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                En accédant et en utilisant TutorMatch HEG, application réalisée par l'AEHEG en partenariat avec la Haute école de gestion de Genève (HEG-Genève), 
                vous acceptez d'être lié-e par ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Ces conditions s'appliquent à tous les utilisateurs et utilisatrices de la plateforme, qu'ils soient étudiant-es, tuteur-trices ou visiteurs.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description du service</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                TutorMatch HEG est une plateforme de mise en relation entre étudiant-es et tuteur-trices de la Haute école de gestion de Genève (HEG). 
                Nous facilitons les connexions entre étudiant-es cherchant de l'aide académique et étudiant-es expérimenté-es proposant du tutorat.
              </p>
              <p className="text-gray-700 leading-relaxed">
                La plateforme permet de rechercher des tuteur-trices, de prendre contact et d'organiser des sessions. Les paiements se font directement entre les parties.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Inscription et compte utilisateur</h2>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">3.1 Conditions d'inscription</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Être étudiant-e ou ancien-ne étudiant-e de la HEG</li>
                <li>Fournir des informations exactes et à jour</li>
                <li>Être âgé d'au moins 18 ans</li>
                <li>Respecter la législation suisse en vigueur</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">3.2 Responsabilités du compte</h3>
              <p className="text-gray-700 leading-relaxed">
                Vous êtes responsable de la confidentialité de vos identifiants de connexion et de toutes les activités effectuées sous votre compte. 
                Vous devez nous informer immédiatement de toute utilisation non autorisée de votre compte.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Utilisation de la plateforme</h2>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">4.1 Utilisation autorisée</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                La plateforme doit être utilisée uniquement à des fins éducatives et académiques légitimes. 
                Toute utilisation commerciale non autorisée est interdite.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">4.2 Comportements interdits</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Harcèlement ou comportement inapproprié envers d'autres utilisateurs ou utilisatrices</li>
                <li>Publication de contenu offensant, discriminatoire ou illégal</li>
                <li>Tentative d'accès non autorisé aux systèmes de la plateforme</li>
                <li>Utilisation de la plateforme pour des activités frauduleuses</li>
                <li>Création de faux profils ou usurpation d'identité</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Services de tutorat</h2>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">5.1 Relation entre tuteur-trice et étudiant-e</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                TutorMatch HEG facilite la mise en relation mais n'est pas partie prenante dans la relation contractuelle 
                entre tuteur-trices et étudiant-es. Chaque partie est responsable de ses engagements respectifs mutuels.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">5.2 Qualité et tarification</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Bien que nous encouragions des standards élevés, nous ne garantissons pas la qualité des services de tutorat. 
                Les utilisateurs et utilisatrices sont encouragé-es à utiliser le système d'évaluation pour maintenir la qualité de la communauté.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Les tarifs sont fixés librement par chaque tuteur-trice. À titre indicatif, les tarifs usuels se situent 
                entre 25 et 50 CHF/heure selon l'expérience et la complexité des matières.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Modèle économique et paiements</h2>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">6.1 Plateforme gratuite</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                TutorMatch HEG est une plateforme de mise en relation entièrement gratuite. 
                Nous ne prélevons aucune commission sur les sessions de tutorat. 
                Notre mission est de faciliter l'entraide entre étudiant-es de la HEG.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">6.2 Transactions directes</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Les paiements se font directement entre étudiant-es et tuteur-trices, en espèces ou via des moyens 
                de paiement numériques (Twint, etc.). TutorMatch HEG n'intervient pas dans ces transactions.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">6.3 Responsabilité des paiements</h3>
              <p className="text-gray-700 leading-relaxed">
                Chaque partie est responsable de ses engagements financiers. En cas de litige concernant 
                un paiement, nous encourageons la résolution amiable, mais la plateforme n'est pas responsable 
                des transactions entre utilisateur-trices.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Protection des données</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nous respectons strictement la Loi fédérale sur la protection des données (LPD) suisse et le RGPD européen. 
                Vos données personnelles sont collectées, traitées et stockées conformément à notre 
                <a href="/confidentialite" className="text-blue-600 hover:text-blue-800 underline"> Politique de confidentialité</a>.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">7.1 Vos droits</h3>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Droit d'accès à vos données personnelles</li>
                <li>Droit de rectification des données inexactes</li>
                <li>Droit à l'effacement de vos données</li>
                <li>Droit à la portabilité de vos données</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Propriété intellectuelle</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tous les contenus de la plateforme (textes, images, logos, code source) sont protégés par le droit d'auteur 
                et appartiennent à TutorMatch HEG ou à ses partenaires.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Les utilisateurs et utilisatrices conservent leurs droits sur les contenus publiés, mais accordent à TutorMatch HEG 
                une licence d'utilisation nécessaire au fonctionnement de la plateforme.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation de responsabilité</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                TutorMatch HEG agit en tant qu'intermédiaire et ne peut être tenu responsable des dommages résultant :
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>De la qualité des services de tutorat fournis</li>
                <li>Des interactions entre utilisateur-trices</li>
                <li>De l'utilisation inappropriée de la plateforme</li>
                <li>D'interruptions techniques temporaires</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Résiliation</h2>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">10.1 Résiliation par l'utilisateur-trice</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Vous pouvez supprimer votre compte à tout moment depuis vos paramètres de profil. 
                La suppression est effective immédiatement, mais certaines données peuvent être conservées 
                pour des obligations légales.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-3">10.2 Résiliation par TutorMatch HEG</h3>
              <p className="text-gray-700 leading-relaxed">
                Nous nous réservons le droit de suspendre ou supprimer un compte en cas de violation 
                de ces conditions d'utilisation, après mise en demeure restée sans effet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Droit applicable et juridiction</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Ces conditions d'utilisation sont régies par le droit suisse. 
                En cas de litige, les tribunaux de Genève sont seuls compétents.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Conformément à la loi suisse, nous privilégions la résolution amiable des conflits 
                avant tout recours judiciaire.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Modifications des conditions</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment. 
                Les utilisateur-trices seront informé-es des modifications importantes par email ou notification sur la plateforme.
              </p>
              <p className="text-gray-700 leading-relaxed">
                La poursuite de l'utilisation de la plateforme après notification des modifications 
                constitue une acceptation des nouvelles conditions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Contact</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Pour toute question concernant ces conditions d'utilisation, vous pouvez nous contacter :
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700 mb-2">
                  <strong>Email :</strong> legal@tutormatch-heg.ch
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Adresse :</strong> Haute école de gestion de Genève<br />
                  Campus de Battelle<br />
                  Rue de la Tambourine 17<br />
                  1227 Carouge, Suisse
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
